module.exports = __webpack_public_path__ + "img/به-انتخاب-طراح.7658a584.jpg";